





































import Vue from "vue";

export default Vue.extend({
	name: "ExpandableBox",
	props: {
		headingClasses: {
			type: String,
			default: ""
		},
		contentClasses: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		showLessTitle: {
			type: String,
			default: ""
		},
		showMoreTitle: {
			type: String,
			default: ""
		},
		startExpanded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return <{
			isExpanded: false, showMoreExpanded: false
		}>{
			isExpanded: false,
			showMoreExpanded: false
		};
	},
	mounted() {
		this.$data.isExpanded = this.$props.startExpanded;
	},
	methods: {
		toggle() {
			this.$data.isExpanded = !this.$data.isExpanded;
		},
		toggleShowMore() {
			this.$data.showMoreExpanded = !this.$data.showMoreExpanded;
		}
	}
});
